import React, { useState } from 'react';
import FileUpload, {
  UPLOAD_FILE_TYPES,
} from 'legacy/src/components/content/controls/FileUpload';
import media from 'legacy/src/components/content/types/media/audio';

export const AUDIO_FILE_EXTENSIONS = ['mp4', 'mp3', 'wav', 'm4a', 'wma'];
const Audio = ({ cursor }) => {
  const contentCursor = cursor.sub(['content']);

  const [state] = useState({});

  const getProcessedURL = (result, etag) => {
    const contentType = result.content_type.split('/')[1];
    const path = `${etag}/original.${
      contentType === 'mpeg' ? 'mp3' : contentType
    }`;
    return `${S3_MEDIA_URL}${path}`;
  };

  const onProcessed = (result, etag) => {
    contentCursor.requestChange({
      ...contentCursor.value,
      src: getProcessedURL(result, etag),
    });
  };

  return (
    <div>
      <FileUpload
        fileType={UPLOAD_FILE_TYPES.AUDIO}
        getProcessedURL={getProcessedURL}
        onProcessed={onProcessed}
        allowedFileExtensions={AUDIO_FILE_EXTENSIONS}
      />
      Preview:{' '}
      {contentCursor.value.src && state.uploading !== true && (
        <media.Player item={{ content: contentCursor.value }} />
      )}
    </div>
  );
};

export default Audio;
